import { render } from "./TargetCustomerDetail.vue?vue&type=template&id=335e2c1e&scoped=true"
import script from "./TargetCustomerDetail.vue?vue&type=script&lang=js"
export * from "./TargetCustomerDetail.vue?vue&type=script&lang=js"

import "./TargetCustomerDetail.vue?vue&type=style&index=0&id=335e2c1e&scoped=true&lang=css"
import "./TargetCustomerDetail.vue?vue&type=style&index=1&id=335e2c1e&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335e2c1e"]])

export default __exports__